import showdown from "showdown";
const md = new showdown.Converter();

function setIframeAspectRatios(content) {
  const iframeRegex = /<iframe[^>]*width="(\d+)"[^>]*height="(\d+)"[^>]*>/g;
  return content.replace(iframeRegex, (match, width, height) => {
    const aspectRatio = width / height;
    return match.replace(/>/g, ` style="aspect-ratio: ${aspectRatio}">`);
  });
}

const useParseMarkdown = () => {
  return (content) => {
    if (!content) return null;

    const processedContent = setIframeAspectRatios(content);
    return md.makeHtml(processedContent);
  };
};

export default useParseMarkdown;